import React, { Component } from 'react';
import Translate from 'react-translate-component';
import ButtonLoader from './ButtonLoader';
import './Button.scss';

interface IButton {
  title: string,
  disabled?: boolean,
  isVisible?: boolean,
  onClick?: (event: any) => void,
  isLoading?: boolean,
  isFullWidth?: boolean,
  translateWith?: object,
  buttonType?: "general" | "custom" | "add" | "light" | "error" | "success" | "with-shadow",
  type?: "button" | "submit" | "reset" | undefined,
  id: string,
  icon?: string,
  style?: object,
  className?: string,
  shouldTranslate?: boolean,
  tabIndex?: number
}

const Button: React.FC<IButton> = (props) => {
  const {
    title = "Button title",
    disabled = false,
    isVisible = true,
    onClick = () => { },
    isLoading = false,
    isFullWidth = false,
    translateWith = {},
    buttonType = "general",
    type = "button",
    id = "",
    icon = "",
    style = {},
    className = "",
    shouldTranslate = true,
    tabIndex = 0,
  } = props;

  const fullWidthClassName: string = isFullWidth ? "btn-full" : "";

  if (!isVisible) {
    return null;
  }

  if (isLoading) {
    return (
      <button
        id={id}
        type={type}
        className={`button ${fullWidthClassName} btn-basic btn-${buttonType} ${className}`}
        disabled
        style={style}
        tabIndex={tabIndex}
      >
        <ButtonLoader />
      </button>
    );
  }

  return (
    <button
      id={id}
      type={type}
      className={`button ${fullWidthClassName} btn-basic btn-${buttonType} ${className} ${disabled ? 'btn-disabled' : ''}`}
      disabled={disabled || buttonType === "success"}
      onClick={onClick}
      style={style}
      tabIndex={tabIndex}
    >
      {icon ? <i className={`button-icon ${icon}`} /> : null}

      {
        shouldTranslate
          ? <Translate content={title} component="span" with={translateWith} />
          : <span>{title}</span>
      }

    </button>
  );
}

export default Button;
